import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2 } from "lucide-react";
import { B2bStatsCardProps } from "@/services/organizationsApi";

export function B2bOrgsStatCard({ stats, loading, error }: B2bStatsCardProps) {
  const b = stats?.business;
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Organisations</CardTitle>
        <Building2 className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {loading && (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        )}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {!loading && !error && b && (
          <>
            <div className="text-2xl font-bold">{b.total_orgs}</div>
            <div className="flex flex-wrap gap-2 mt-1 text-xs text-muted-foreground">
              <span>{b.business_orgs} entreprise</span>
              <span>{b.personal_orgs} perso</span>
              {b.converted_business > 0 && (
                <span>{b.converted_business} converties</span>
              )}
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
